import { FocusMetrics } from "@radarly/models/aicha";
import { BaseSearchParams } from "@radarly/models/search";

export interface AichaRepo {
  getDiscoveryPostlistSummary(
    pid: number,
    request: BaseSearchParams,
    focusMetrics: FocusMetrics[]
  ): Promise<{ data: string } | null>;
  getPostlistSummary(
    pid: number,
    request: BaseSearchParams,
    focusMetrics: FocusMetrics[]
  ): Promise<{ data: string } | null>;
}

export const AichaRepositoryUID = Symbol("Radarly/AichaRepository");
